import { render, staticRenderFns } from "./DriverBaiganiDocumentList.vue?vue&type=template&id=d7a60190&"
import script from "./DriverBaiganiDocumentList.vue?vue&type=script&lang=js&"
export * from "./DriverBaiganiDocumentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports